import getUrl from './getUrl.js';

export default function singleListing(idListing) {
  return fetch(`${getUrl()}/v2/listing/${idListing}`, {
    method: 'GET',
    headers: {
      'Content-type':'application/json'
    },
    credentials: 'include',
  })
  .then((res) => res.json())
}